import { Select } from "antd";
import { useState } from "react";

// a place typed in that isn't in the master list yet is held as "new:<name>" until the form is saved,
// then the server finds it (ignoring capitals) or adds it
const NEW_PREFIX = 'new:'
export const isNewPlace = (value) => typeof value === 'string' && value.startsWith(NEW_PREFIX)
export const newPlaceName = (value) => (isNewPlace(value) ? value.slice(NEW_PREFIX.length) : '')

const clean = (text) => (text || '').replace(/\s+/g, ' ').trim()

// searchable country / state / city dropdown that also offers to add what was typed
// other props from Form.Item (like the field's id) go on to the Select
export const PlaceSelect = ({ value, onChange, options, placeholder, disabled, ...rest }) => {
    const { Option } = Select
    const [search, setSearch] = useState('')

    const typed = clean(search)
    const exists = options.some((option) => clean(option.name).toLowerCase() === typed.toLowerCase())
    // keep showing a new place once it's picked, so its name stays in the box
    const pickedNew = isNewPlace(value) ? newPlaceName(value) : ''

    return (
        <Select
            {...rest}
            className="mt-2"
            showSearch
            value={value}
            onChange={(picked) => { setSearch(''); onChange && onChange(picked) }}
            onSearch={setSearch}
            onBlur={() => setSearch('')}
            // the "Add" option always stays visible; the rest filter by name
            filterOption={(input, option) => isNewPlace(option.value) || (option.children || '').toString().toLowerCase().includes(input.toLowerCase())}
            disabled={disabled}
            placeholder={placeholder}
            notFoundContent={null}
        >
            <Option value="" disabled hidden>
                {placeholder}
            </Option>
            {options.map((option) => (
                <Option key={option.id} value={option.id}>
                    {option.name}
                </Option>
            ))}
            {typed && !exists && (
                <Option key="add" value={NEW_PREFIX + typed}>
                    {`Add "${typed}"`}
                </Option>
            )}
            {pickedNew && pickedNew !== typed && (
                <Option key="picked" value={value}>
                    {`${pickedNew} (new)`}
                </Option>
            )}
        </Select>
    )
}
